export default class BaseService {
    _urlRender = (_url, data) => {
        let url = _url;//(_url.indexOf('/') === 0 ? _url : ('/' + _url));
        if (data) {
            url += "?";
            url = this._dataQueryRender(data, url, "").replace(/&$/, "");
        }
        return url;
    };

    _dataQueryRender = (data, url, prefix) => {
        let rUrl = url;
        if (data && data.constructor === Array) {
            for (let key in data) {
                if (data[key] && data[key].constructor === Object) {
                    rUrl += this._dataQueryRender(data[key], "", (prefix ? prefix + "[" + key + "]" : key));
                } else {
                    rUrl += (prefix ? prefix + "[" + key + "]" : key) + "=" + ((data[key] !== undefined && data[key] !== null) ? encodeURI(data[key]) : "") + "&";
                }
            }
        } else if (data) {
            for (let key in data) {
                if (data[key] && data[key].constructor === Object) {
                    rUrl += this._dataQueryRender(data[key], "", (prefix ? prefix + "." + key : key));
                } else if (data[key] && data[key].constructor === Array) {
                    rUrl += this._dataQueryRender(data[key], "", (prefix ? prefix + "." + key : key));
                } else {
                    rUrl += (prefix ? prefix + "." + key : key) + "=" + ((data[key] !== undefined && data[key] !== null) ? encodeURI(data[key]) : "") + "&";
                }
            }
        }
        return rUrl;
    }
}